import {TiMeLogger} from 'features/logger';

export const SidebarLogger = TiMeLogger.child({name: 'sidebar'});
